import {
  createGet,
  createGetByDates,
  createPost,
  createPatch,
  createDownload,
} from "./base.js";

export const GetMotivation = createGet("motivation");
export const GetByDatesMotivation = createGetByDates("motivation");
export const PostMotivation = createPost("motivation");
export const PatchMotivation = createPatch("motivation");
export const DonwloadMotivation = createDownload("motivation/download");
